import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { DataProduct } from 'src/app/generales/login/pages/perfil/interfaces-perfil/interfacesPerfil';
import { environment } from 'src/environments/environment';
import { ModalContactoVendedorComponent } from '../../../../generales/components/modal-contacto-vendedor/modal-contacto-vendedor.component';

@Component({
  selector: 'app-product-presentation',
  templateUrl: './product-presentation.component.html',
  styleUrls: ['./product-presentation.component.scss'],
})
export class ProductPresentationComponent implements OnInit {
  constructor(private modalCtrl: ModalController, private router:Router) {}
  @Input() data: DataProduct;

  ngOnInit() {
    console.log(this.data);
    
  }

  url:string = environment.url;
  toglleFavorites: boolean = false;
  icon: string = 'star-outline';

  toglleFavorite() {
    this.toglleFavorites ? (this.icon = 'star-outline') : (this.icon = 'star');
    this.toglleFavorites = !this.toglleFavorites;
  }

  async openContact() {
    const contact = {
      number: this.data.number,
      number_wp: this.data.numberWp,
    };
    const modal = await this.modalCtrl.create({
      component: ModalContactoVendedorComponent,
      cssClass: 'custom-modal',
      componentProps: { contact, title: 'Contacta al Vendedor' },
    });

    modal.present();
  }

  goTo(){
    let userId = Number(this.data.userId)
    let storeId = Number(this.data.storeId)
    if(userId){
      this.router.navigate([`/market-place/user/${userId}/1`])
    }else{
      this.router.navigate([`/market-place/store/${storeId}/1`],
      {
        queryParams:
        {
          name: this.data.store.business_name.replace(/ /g, '-')
        }
      })
    }
  }
}
